import AccountActionTypes from 'app/redux-boneyard/account/ActionTypes';
import reducer from 'app/redux-boneyard/account/reducer';
import routes from 'app/account/routes';

export default {
  reducers: {
    account: reducer,
  },
  actionTypes: AccountActionTypes,
  routes,
};
